import { render, staticRenderFns } from "./gl-img.vue?vue&type=template&id=07bb7fb4"
import script from "./gl-img.vue?vue&type=script&lang=js"
export * from "./gl-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports